<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <DeputyForm :formProps="formProps">
                </DeputyForm>
            </template>
            <template #search="searchProps">
                <DeputySearch :searchProps="searchProps">
                </DeputySearch>
            </template>
        </v-view>
    </div>

</template>

<script setup>
import { ref } from "vue";
import DeputyForm from './DeputyForm.vue'
import DeputySearch from './DeputySearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const isLoading = ref(false)

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
